import YouTubeHelp from './YouTube'
import Periscope from './Periscope'
import Facebook from './Facebook'
import Twitch from './Twitch'
import Wowza from './Wowza'
import RTMPS from './RTMPS'

export default {
    'YouTube': YouTubeHelp,
    'Wowza': Wowza,
    'Twitter-Periscope': Periscope,
    'Facebook-Live': Facebook,
    'Twitch': Twitch,
    "RTMPS": RTMPS
    // 'default': RTMPS
}